import SearchBar from '@/components/company/filters/SearchBar';
import FilterSelect from '@/components/company/filters/FilterSelect';
import ClearFilterButton from '@/components/company/filters/ClearFilterButton';

export const TrainFilters = ({
  searchTerm,
  setSearchTerm,
  selectedRole,
  setSelectedRole,
  selectedCategory,
  setSelectedCategory,
  selectedStatus,
  setSelectedStatus,
  clearFilters,
  roleOptions,
  categoryOptions,
}: any) => (
  <div className="flex justify-start mt-5 px-5 gap-2">
    <SearchBar value={searchTerm} onChange={setSearchTerm} placeholder="Search trainings..." className="w-72" />
    <FilterSelect label="Role" options={roleOptions} value={selectedRole} onChange={setSelectedRole} />
    <FilterSelect label="Category" options={categoryOptions} value={selectedCategory} onChange={setSelectedCategory} />
    <FilterSelect
      label="Status"
      options={[
        { label: 'Published', value: 'Published' },
        { label: 'Unpublished', value: 'Unpublished' },
      ]}
      value={selectedStatus}
      onChange={setSelectedStatus}
    />
    <ClearFilterButton onClear={clearFilters} />
  </div>
);
